import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
interface HeroProps {
  onScrollToPricing: () => void;
}
export function Hero({
  onScrollToPricing
}: HeroProps) {
  return <section className="relative pt-8 pb-10 md:pt-14 md:pb-20 px-4 md:px-6 overflow-hidden" data-id="element-130">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-131">
        {/* Primary title */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-navy-900 leading-tight mb-5 md:mb-8" data-id="element-132">
          Prepara tu próximo encuentro de catequesis en menos de 10 minutos
        </motion.h1>

        {/* Mockup at 70% size */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full flex justify-center" data-id="element-133">
          <div className="absolute inset-0 bg-gold-500/10 rounded-full blur-3xl" data-id="element-134"></div>
          <img src="https://cdn.magicpatterns.com/uploads/m2otS317RFU2spiMqVJj8K/ChatGPT_Image_16_jun_2026,_07_28_27_p.m..png" alt="MegaKit de Catequesis Infantil" loading="eager" fetchPriority="high" decoding="async" width={384} height={384} className="relative z-10 w-[70%] max-w-sm mx-auto drop-shadow-2xl" data-id="element-135" />
        </motion.div>

        {/* Small structural product label (not a heading) */}
        <p className="text-xs md:text-sm font-medium uppercase tracking-widest text-gold-600/90 mt-3 mb-5 md:mb-6" data-id="element-136">
          MegaKit de Catequesis Infantil
        </p>

        {/* Subtitle */}
        <p className="text-base md:text-xl text-navy-900/80 mb-5 md:mb-6 font-medium max-w-2xl" data-id="element-137">
          Más de 100 actividades, dinámicas y recursos listos para usar con
          niños de 6 a 12 años. Sin improvisar. Sin perder horas buscando en
          internet.
        </p>

        {/* Quote */}
        <div className="bg-white/60 backdrop-blur-sm border border-gold-500/30 p-3 md:p-4 rounded-xl mb-6 md:mb-8 italic text-navy-900/90 font-serif text-base md:text-lg shadow-sm max-w-xl" data-id="element-138">
          "Descargás hoy y llegás al primer encuentro de la semana con todo
          preparado."
        </div>

        {/* CTA */}
        <motion.button whileHover={{
        y: -2,
        boxShadow: '0 6px 20px rgba(200,162,74,0.3)'
      }} whileTap={{
        scale: 0.98
      }} onClick={onScrollToPricing} className="w-full sm:w-auto bg-gold-500 hover:bg-gold-600 text-white font-bold py-3 md:py-4 px-6 md:px-8 rounded-full text-base md:text-lg shadow-[0_4px_14px_0_rgba(200,162,74,0.39)] transition-colors flex items-center justify-center gap-2" data-id="element-139">
          💛 QUIERO MI MEGAKIT AHORA
        </motion.button>

        {/* Trust row */}
        <div className="mt-5 md:mt-6 flex flex-wrap justify-center gap-x-3 gap-y-2 text-xs md:text-sm text-navy-900/70 font-medium" data-id="element-140">
          <span className="flex items-center gap-1" data-id="element-141">
            <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-500" data-id="element-142" /> Acceso
            inmediato
          </span>
          <span className="flex items-center gap-1" data-id="element-143">
            <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-500" data-id="element-144" />{' '}
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1" data-id="element-145">
            <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-500" data-id="element-146" /> Pago
            seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-147">
            <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-500" data-id="element-148" />{' '}
            Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}